import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Parallax } from 'react-parallax'

import { Subsections } from './'

class ParallaxSection extends Component {
    render() {
        const { image, strength, data, css } = this.props

        return (
            <div className={` ${css}`}>
                <Parallax bgImage={image} strength={strength} blur={{ min: -5, max: 10 }} >
                    <div style={{ background: 'rgba(0,0,0,.6)', color: 'white' }}>
                        <div className="container text-center" style={{ paddingTop: 80, paddingBottom: 80 }}>
                            <h3>{data.title}</h3>
                            <Subsections subsections={data.sections} />
                        </div>
                    </div>
                </Parallax>
            </div>
        )
    }
}

ParallaxSection.propTypes = {
    image: PropTypes.string.isRequired,
    strength: PropTypes.number,
    height: PropTypes.number.isRequired
}

ParallaxSection.defaultProps = {
    strength: 200
}

export { ParallaxSection }


// WEBPACK FOOTER //
// ./src/components/sections/ParallaxSection.js